/* eslint-disable @typescript-eslint/no-var-requires */
const { Colors } = require('./colors')

const Card = {
  background: Colors.grey1,
  mapCardPadding: '30px',
}

module.exports = { Card }
